export  const styles = {
    // GLOBAL KEYFRAMES
    "@keyframes fadeIn": {
      from: { opacity: 0 },
      to: { opacity: 1 },
    },
    "@keyframes slideUp": {
      from: { opacity: 0, transform: "translateY(20px)" },
      to: { opacity: 1, transform: "translateY(0)" },
    },


    

    container: {
      minHeight: "100vh",
      background: "linear-gradient(to bottom, #eaf2ff, #f7fbff)",
      padding: "32px",
      fontFamily: "'Segoe UI', sans-serif",
    },

    card: {
      background: "rgba(255, 255, 255, 0.85)",
      backdropFilter: "blur(12px)",
      borderRadius: "22px",
      padding: "28px",
      boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
      marginBottom: "30px",
      transition: "0.4s ease",
    },

    cardHover: {
      transform: "translateY(-4px)",
      boxShadow: "0 14px 40px rgba(0,0,0,0.1)",
    },

    header: {
      fontSize: "20px",
      fontWeight: "800",
      color: "#1d2d50",
      marginBottom: "12px",
    },

    subText: {
      color: "#5f6f85",
      fontSize: "15px",
      marginTop: "-6px",
      opacity: 0.8,
    },

    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
      gap: "25px",
      marginTop: "22px",
    },

    statBox: {
      background: "linear-gradient(135deg, #ffffff 0%, #f3f7ff 100%)",
      padding: "26px",
      borderRadius: "20px",
      boxShadow: "0 4px 18px rgba(0,0,0,0.06)",
      textAlign: "center",
      border: "1px solid #e6ecf5",
      transition: "0.35s ease",
      cursor: "pointer",
    },

    statBoxHover: {
      transform: "scale(1.06)",
      boxShadow: "0 10px 28px rgba(0,0,0,0.09)",
    },

    statLabel: {
      fontSize: "14px",
      color: "#6d7c92",
      marginBottom: "8px",
      fontWeight: "500",
      letterSpacing: "0.2px",
    },

    statValue: {
      fontSize: "34px",
      fontWeight: "900",
      color: "#1d2d50",
    },

    tableContainer: {
      overflowX: "auto",
      marginTop: "15px",
      borderRadius: "16px",
    },

    table: {
      width: "100%",
      borderCollapse: "collapse",
      minWidth: "700px",
    },

    th: {
      background: "#edf3ff",
      padding: "15px",
      textAlign: "left",
      fontWeight: "700",
      fontSize: "15px",
      color: "#3d4e65",
      borderBottom: "2px solid #d9e4f5",
    },

    td: {
      padding: "15px",
      borderBottom: "1px solid #ebf0fa",
      fontSize: "15px",
      color: "#2b3b52",
    },

    statusConfirmed: {
      padding: "7px 16px",
      background: "#dbffe6",
      color: "#0c6f32",
      borderRadius: "14px",
      fontWeight: "700",
      fontSize: "13px",
      display: "inline-block",
    },

    statusPending: {
      padding: "7px 16px",
      background: "#fff1d9",
      color: "#9b6b00",
      borderRadius: "14px",
      fontWeight: "700",
      fontSize: "13px",
      display: "inline-block",
    },
  };